import { Cores } from 'src/componentes/styles/cores'
import styled from 'styled-components'

export const Conteudo = styled.main`
  display: flex;
  flex-direction: column;
  margin: 18px 30px;
  gap: 20px;
`

export const ContainerLink = styled.div`
  margin-bottom: 28px;
`

export const BlocoComEdicao = styled.div`
  position: relative;
`

export const BotaoEditarBloco = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  cursor: pointer;
  color: ${Cores.PRIMARIA_1};
  padding: 4px;

  svg {
    width: 18px;
    height: 18px;
  }
`

export const Grade = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px 32px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const Campo = styled.div`
  display: flex;
  flex-direction: column;

  span.rotulo {
    font-size: 12px;
    color: ${Cores.CINZA_2_CLARO};
    margin-bottom: 4px;
  }

  span.valor {
    font-size: 14px;
    color: ${Cores.CINZA_1};
    font-weight: 500;
  }
`

export const AcoesFinanceiro = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid ${Cores.CINZA_3};

  /* texto informativo "Cobrança já gerada" — filho direto, não afeta o <span> interno do Botão */
  > span {
    font-size: 13px;
    color: ${Cores.CINZA_2_CLARO};
  }
`

export const AcoesGerais = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid ${Cores.CINZA_3};
`

export const BadgeStatus = styled.span<{ fundo: string; corTexto: string }>`
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  width: fit-content;
  background-color: ${({ fundo }) => fundo};
  color: ${({ corTexto }) => corTexto};
`

export const TituloBloco = styled.h4`
  margin: 0 0 12px;

  & + & {
    margin-top: 32px;
  }
`

export const ListaChat = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
`

export const ItemChat = styled.div`
  padding: 10px 12px;
  border-radius: 6px;
  background-color: ${Cores.CINZA_3_MAIS_CLARO};

  .cabecalho {
    font-size: 11px;
    color: ${Cores.CINZA_2_CLARO};
    margin-bottom: 4px;
  }

  .texto {
    font-size: 14px;
    color: ${Cores.CINZA_1};
  }
`

export const NovaObservacao = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  textarea {
    width: 100%;
    min-height: 72px;
    padding: 10px;
    border: 1px solid ${Cores.CINZA_3};
    border-radius: 6px;
    resize: vertical;
    font-family: inherit;
  }

  button {
    align-self: flex-end;
  }
`

export const Timeline = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const ItemTimeline = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 2px 0 2px 14px;
  border-left: 2px solid ${Cores.PRIMARIA_2};

  .titulo {
    font-size: 14px;
    color: ${Cores.CINZA_1};
    font-weight: 500;
  }

  .meta {
    font-size: 11px;
    color: ${Cores.CINZA_2_CLARO};
  }
`
